import { useCallback } from "react";

import { useProductDayTripPlanFormModelContext } from "../../../../../context";

const NULL = "null";
const isNULL = (input: string) => input === NULL;

export const usePlanAvailableDiscountIDs = () => {
	const { viewModel, onSetViewModel, queryData } = useProductDayTripPlanFormModelContext();
	const { defaultDiscountID } = viewModel;
	const { discountNameAndIDOptions: _discountNameAndIDOptions } = queryData.connection;

	const discountNameAndIDOptions = [
		{ id: "defaultDiscountID_0", label: "なし", value: NULL },
		..._discountNameAndIDOptions,
	];

	const onSetDefaultDiscountID = useCallback(
		(input: string) => {
			onSetViewModel([
				{
					key: "defaultDiscountID",
					value: {
						isEdited: true,
						value: isNULL(input) ? null : input,
					},
				},
			]);
		},
		[onSetViewModel],
	);

	return {
		defaultDiscountID,
		onSetDefaultDiscountID,
		discountNameAndIDOptions,
	};
};
